// @flow
import * as React from 'react';
import styled from 'styled-components';
import { SecondaryButton } from 'components/Button';
import Icon from 'components/Icon';
import Box from 'components/Box';
import { colors, mediaRetina, transition } from '../theme';

const SaveButton = styled(({ saved, ...props }: { saved: boolean }) => (
  <SecondaryButton {...props}>
    <Box display="flex" alignItems="center" justifyContent="center" width={1}>
      <Icon name="heart" width={18} height={18} />
      <Box ml="6px">{saved ? getText('Unsave') : getText('Save')}</Box>
    </Box>
  </SecondaryButton>
))`
  svg {
    path {
      transition: all ${transition};
      stroke: ${colors.battleshipGrey};
      fill: transparent;
      stroke-width: 1.5px;
    }
  }
  &:hover {
    color: ${colors.battleshipGrey};
    box-shadow: inset 0 0 0 1px ${colors.battleshipGrey};
    &:not(:disabled) {
      svg {
        path {
          fill: ${colors.turtleGreen};
          stroke: ${colors.turtleGreen};
        }
      }
    }
  }
  @media ${mediaRetina} {
    &:hover {
      box-shadow: inset 0 0 0 1.5px ${colors.battleshipGrey};
    }
  }
`;

export default SaveButton;
